<div class="video-container" #videoContainer>
  <video
    #video
    class="video-hidden"
    [src]="previewUrl"
    [muted]="hasMainSeparateAudio || muted || activeSourceIndex !== -1"
    crossorigin="anonymous"
    *ngIf="previewUrl"
  ></video>
  <!-- Hidden clone used only for capturing thumbnails at specific times (avoids seeking the visible video). -->
  <video
    #videoThumbnailCapture
    class="video-thumbnail-capture"
    [src]="previewUrl"
    muted
    crossorigin="anonymous"
    preload="auto"
    *ngIf="previewUrl"
  ></video>
  <!-- Hidden videos for appended MAM segments (multi-source timeline). -->
  <ng-container *ngIf="appendedMamSegments?.length">
    <video
      #appendedVideo
      *ngFor="let seg of appendedMamSegments; let i = index"
      [src]="seg.previewUrl"
      class="video-hidden"
      [muted]="hasAppendedSeparateAudio(i) || muted || activeSourceIndex !== i"
      crossorigin="anonymous"
      preload="auto"
    ></video>
  </ng-container>
  <!-- Hidden videos for Edit-mode MAM clips (clips with previewUrl). -->
  <ng-container *ngIf="orderedEditMamClips.length">
    <video
      #editMamVideo
      *ngFor="let clip of orderedEditMamClips"
      [src]="clip.previewUrl"
      class="video-hidden"
      [muted]="hasEditMamSeparateAudio(clip) || muted || activeSourceKey !== 'editMam-' + clip.id"
      crossorigin="anonymous"
      preload="auto"
    ></video>
  </ng-container>
  <canvas #previewCanvas class="preview-canvas" *ngIf="previewUrl && !reframeConfig"></canvas>
  <canvas #previewCanvas2d class="preview-canvas" *ngIf="previewUrl && reframeConfig"></canvas>
  <canvas
    #mainOverlayCanvas
    class="main-overlay-canvas"
    [class.main-overlay-canvas--interactive]="isEditMode"
    *ngIf="previewUrl"
    (pointerdown)="onOverlayPointerDown($event)"
    (pointermove)="onOverlayPointerMove($event)"
    (pointerup)="onOverlayPointerUp($event)"
    (pointerleave)="onOverlayPointerLeave()"
  ></canvas>
  <canvas #subtitlesCanvas class="subtitles-canvas" *ngIf="previewUrl"></canvas>
  <div class="video-loading" *ngIf="previewUrl && !videoFrameReady">
    <span>Loading video...</span>
  </div>
  <div class="no-video" *ngIf="!previewUrl">
    <span>No video loaded</span>
  </div>
  <div #gfxIframeContainer class="gfx-iframe-container"></div>
</div>
